import { NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { SnackBarPanelClass } from 'src/app/services/toast.service';

export interface NotificationData {
  icon: string;
  title: string;
  description: string | null;
  action: string | null;
  panelClass: SnackBarPanelClass;
}

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    imports: [MatButtonModule, MatIconModule, NgIf]
})
export class NotificationComponent {
  snackBarRef = inject(MatSnackBarRef);
  data: NotificationData = inject(MAT_SNACK_BAR_DATA);

  getButtonColor(panelClass: SnackBarPanelClass): string {
    switch (panelClass) {
      case 'deleted-snackbar': {
        return 'primary';
      }
      case 'error-snackbar': {
        return 'warn';
      }
      case 'success-snackbar': {
        return 'accent';
      }
    }
  }
}
